exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pR_2hXPxwZ5j44MfHvtXc,._3fHUWMUNZDvbk8fpPLCZO8{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] .pR_2hXPxwZ5j44MfHvtXc,html[dir] ._3fHUWMUNZDvbk8fpPLCZO8{padding:10px;background-color:\"[theme:neutralLighter, default:#f3f2f1]\"}html[dir] .h16NM0HfKiP834YL6_L1v{padding-top:4px;-webkit-padding-end:inherit;padding-inline-end:inherit}", ""]);
// Exports
exports.locals = {
	"accessIssueInfoBar": "pR_2hXPxwZ5j44MfHvtXc",
	"errorInfoBar": "_3fHUWMUNZDvbk8fpPLCZO8",
	"infoBarIcon": "h16NM0HfKiP834YL6_L1v"
};